module.exports = __webpack_public_path__ + "img/pepper-redirect-info-icon.1614a7ca.svg";